import { render } from "./Schedule.vue?vue&type=template&id=11365230&scoped=true"
import script from "./Schedule.vue?vue&type=script&lang=js"
export * from "./Schedule.vue?vue&type=script&lang=js"

import "./Schedule.vue?vue&type=style&index=0&id=11365230&lang=scss&scoped=true"
import "./Schedule.vue?vue&type=style&index=1&id=11365230&lang=css"

import exportComponent from "/home/nodeapps/uzb/frontendBuild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11365230"]])

export default __exports__